export default __webpack_public_path__ + "static/media/home1.29eb6735.jpg";